<template>
  <div>
    <div class="masterbook_division">
      <div v-if="backgroundImgURL" class="index-content-left">
        <div
          class="list-item__thumbnail"
          :style="backgroundImageFromApi(backgroundImgURL)"
        />
      </div>
      <div
        :class="[
          backgroundImgURL ? 'index-content-right' : 'index-content-center',
        ]"
      >
        <div class="list-item item__1">
          {{ listItem1 }}
        </div>

        <div class="list-item item__2">
          <a
            v-if="listItem2"
            v-html="
              newlineConvert(
                listItem2
                  .replace(/\[BACKSLASH\]/g, '')
                  .replace(/\[NL\]/g, '<br>')
              )
            "
          />
        </div>

        <p v-if="listItem3" class="list-item__title item__3">{{ listItem3 }}</p>
      </div>
      <div class="cb"></div>

      <div class="list-item item__3">
        <button class="button_go_to_place" @click="button1Action()">
          <img
            src="@/assets/img/icon/png/i_goto.png"
            alt=""
            style="margin-right: 2px"
          /><span class="button_text">ここに行く</span>
        </button>

        <button class="button_detail" @click="button2Action()">
          <img
            src="@/assets/img/icon/png/i_details.png"
            style="margin-right: 5px"
            alt=""
          /><span class="button_text">詳細</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheFacilityCard",
  props: {
    backgroundImgURL: {
      type: String,
      required: false,
    },
    listItem1: {
      type: String,
      required: true,
    },
    listItem2: {
      type: String,
      required: false,
      default: null,
    },
    listItem3: {
      type: String,
      required: true,
    },
    button1Action: {
      type: Function,
      required: true,
    },
    button2Action: {
      type: Function,
      required: true,
    },
  },
  methods: {
    // handleClick() {
    //   this.$emit("clicked");
    // }
  },
};
</script>

<style lang="scss" scoped>
.index-content-left {
  float: left;
  width: 20%;
  padding: 9px 10px 9px 10px;
}

.list-item__thumbnail {
  width: 76px;
  height: 76px;
  border-radius: 0px;
  background-size: cover;
}

.cb {
  clear: both;
}

.index-content-right {
  overflow: hidden;
  position: relative;
  width: 65%;
  height: 76px;
  padding-left: 5%;
  padding-top: 10px;
}

.index-content-center {
  overflow: hidden;
  position: relative;
  width: 95%;
  height: 76px;
  padding-left: 5%;
  padding-top: 10px;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 69%;
  height: 1.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.list-item {
  position: absolute;
  width: 100%;
  height: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.item__1 {
  top: 20%;
  font-size: 11px;
}

.item__2 {
  top: 44%;
  font-size: 13px;
  height: 13px;
  line-height: 15px;
}

.item__3 {
  position: relative;
  height: unset;
  button {
    width: 49.07%;
    height: 42px;
    margin: 1px 1px;
    font-size: 13px;
    padding: 0 0 8px 0;
    display: table-cell;
    vertical-align: middle;
    border: 1px solid #e0e0e0;
    background: white;

    img {
      width: 27px;
      position: relative;
      top: 8px;
    }

    .button_text {
      color: #000000;
    }
  }
  button.button_go_to_place {
    border-radius: 0px 0px 0px 10px;
  }
  button.button_detail {
    border-radius: 0px 0px 10px 0px;
  }
  button:first-child {
    margin-left: 0.62%;
  }
}

.masterbook_division {
  border-bottom: none;
}
</style>
